import { ButtonHTMLAttributes, ReactNode } from 'react'
import { StyledGlassButton } from './styles'

type Props = {
  children: ReactNode
} & ButtonHTMLAttributes<HTMLButtonElement>

export default function GlassButton({ children, type, ...rest }: Props) {
  return (
    <StyledGlassButton type={type || 'button'} {...rest}>
      {children}
    </StyledGlassButton>
  )
}
